import React, { createContext, useContext, useState } from "react";
import SweetAlert2 from "react-sweetalert2";
import PropTypes from "prop-types";

const SweetAlertContext = createContext();

export const useSweetAlert = () => {
  const context = useContext(SweetAlertContext);
  if (!context) {
    throw new Error("useSweetAlert must be used within an SweetAlertProvider");
  }
  return context;
};

export const SweetAlertProvider = ({ children }) => {
  const [swalProps, setSwalProps] = useState({});

  const defaultSweetAlertProps = {
    show: false,
    title: "SweetAlert",
    text: "This is a default sweet alert.",
    icon: "info", // warning, success, info, error, question,
    confirmButtonText: "OK",
    cancelButtonText: "Cancel",
    showCancelButton: false,
    showLoaderOnConfirm: false,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    timer: null,
    timerProgressBar: false,
    allowOutsideClick: true,
    allowEscapeKey: true,
    allowEnterKey: true,
    didClose: () => {
      setSwalProps({});
    },
    onConfirm: () => {},
  };

  const showSweetAlert = (props) => {
    const mergedProps = {
      ...defaultSweetAlertProps,
      ...props,
    };
    setSwalProps(mergedProps);
  };

  const hideSweetAlert = () => {
    setSwalProps({});
  };

  return (
    <SweetAlertContext.Provider value={{ showSweetAlert, hideSweetAlert }}>
      {children}
      <SweetAlert2 {...swalProps} />
    </SweetAlertContext.Provider>
  );
};

SweetAlertProvider.propTypes = {
  children: PropTypes.node,
};
